<app-tables
  [tableHeader]="tableHeader"
  [footerText]="footerText"
  [columns]="columns"
  [filters]="filters"
  [url]="url"
  (onActionButtonClick)="actionButtonClick($event.actionType, $event.row)"
  [columnWidths]="columnWidths"
  [type]="'appointmentList'"
></app-tables>


<!-- [data]="appointmentList"
  [totalCount]="totalWorkListCount"
  (filtersChange)="filterWorkList($event.filters, $event.sort)"
  (onPageChange)="onPageChange($event)"
  (onPageSizeChange)="onPageSizeChange($event)"
  [tableLoading]="workListLoading"
  [totalPage]="totalPage"
  [pageSize]="pageSize"
  (handleGetAppointmentList)="getAppointmentList(1, pageSize, filters)"
   -->
